module.exports = __webpack_public_path__ + "img/map2.4223fc61.png";